import { render, staticRenderFns } from "./UsersListHeader.vue?vue&type=template&id=37cd2f3e&scoped=true&"
import script from "./UsersListHeader.vue?vue&type=script&lang=js&"
export * from "./UsersListHeader.vue?vue&type=script&lang=js&"
import style0 from "./UsersListHeader.vue?vue&type=style&index=0&id=37cd2f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd2f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
